import { createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: "#004F9F",
      dark: "#004F9F",
    },
    secondary: {
      main: "#004F9F",
    },
  },
  overrides: {
    MuiStepIcon: {
      root: {
        "&$active": {
          color: "#004F9F",
        },
        "&$completed": {
          color: "#004F9F",
        },
      },
    },
    MuiStepLabel: {
      label: {
        "&$active": {
          color: "#004F9F",
        },
        "&$completed": {
          color: "#004F9F",
        },
      },
    },
    MuiButton: {
      outlined: {
        borderRadius: 0,
        padding: "8px 8px",
        textTransform: "none",
      },
    },
    MuiFormLabel: {
      asterisk: {
        color: "#f00",
      },
    },
  },
  typography: {
    fontWeightMedium: 500,
    body1: {
      fontFamily: "Roboto",
      textTransform: "none",
      fontWeight: "bold",
    },
    h2: {
      fontFamily: "Roboto",
      fontWeight: "bold",
      textAlign: "center",
      textShadow: "0px 6px 14px rgba(24, 39, 75, 0.12)",
    },
    h3: {
      fontFamily: "Roboto",
    },
    h4: {
      fontFamily: "Roboto",
      fontWeight: "bold",
    },
    h5: {
      fontFamily: "Roboto",
    },
    h6: {
      fontFamily: "Roboto",
      // textTransform: 'uppercase',
      fontWeight: "bold",
    },
  },
});

export default theme;
